import React from "react";

import { Input } from "@mui/material";

import { withStyles } from "tss-react/mui";
import TimeInputStyle from "../../assets/jss/material-dashboard-pro-react/components/customInputStyle";

function TimeInput({ ...props }) {
  const { classes } = props;

  return (
    <Input
      className={classes.underline}
      inputProps={{
        name: props.name,
      }}
      type={"time"}
    />
  );
}

export default withStyles(TimeInput, TimeInputStyle);
